// extracted by mini-css-extract-plugin
export var divider = "SectionDivider-module--divider--6548f";